import { render, staticRenderFns } from "./OnboardingModal.vue?vue&type=template&id=b34ce236&scoped=true&"
import script from "./OnboardingModal.vue?vue&type=script&lang=js&"
export * from "./OnboardingModal.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingModal.vue?vue&type=style&index=0&id=b34ce236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34ce236",
  null
  
)

export default component.exports